import { defineComponent as _defineComponent } from 'vue'
import { ReportsTitleByNumber } from "@/enums/ReportsTitleByNumber";

  interface ReportsByNumberProps {
    title: string;
    number: number | string;
    type?: string;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ReportsByNumber',
  props: {
    title: {},
    number: {},
    type: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

const __returned__ = { props, get ReportsTitleByNumber() { return ReportsTitleByNumber } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})